import { z } from 'zod';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { BaseIntegration } from 'libs/end-to-end/src/types/databases/integrations/base-integration';

export const WorkdayIntegration = BaseIntegration.extend({
  integrationType: z.literal('Workday'),
  usernameSecretReference: SecretReference.optional(),
  passwordSecretReference: SecretReference.optional(),
  employeeHistoryUrlSecretReference: SecretReference.optional(),
  staffingEventsUrlSecretReference: SecretReference.optional(),
  compensationChangeHistoryUrlSecretReference: SecretReference.optional(),
  candidatesUrlSecretReference: SecretReference.optional(),
});

export type WorkdayIntegration = z.infer<typeof WorkdayIntegration>;
